import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const veterinarianCitizenListObject = citizenObject.pick({
  fullName: true,
  nickname: true,
  socialName: true,
  sex: true,
  cpf: true,
  whatsapp: true,
  alternatePhone: true,
  cns: true,
  latitude: true,
  longitude: true,
  fullAddress: true,
  complement: true,
})

export const veterinarianObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  citizenId: citizenObject.shape.id,
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  inactivatedAt: dateOrIsoString().nullish(),
})

export const veterinarianListItemObject = veterinarianObject.merge(veterinarianCitizenListObject)

export const propertyMap = {
  id: sql`veterinarian.id`,
  code: sql`veterinarian.code`,
  citizenId: sql`veterinarian.citizen_id`,
  createdAt: sql`veterinarian.created_at`,
  updatedAt: sql`veterinarian.updated_at`,
  inactivatedAt: sql`veterinarian.inactivated_at`,
}

export type VeterinarianType = z.infer<typeof veterinarianObject>
